import { CompetitionsPage } from './pages';

export const competitionsRoutes = [
  {
    path: 'competitions',
    component: CompetitionsPage,
    requiredPermission: 'competitions.view',
  },
];
